import React from "react";
import { graphql } from "gatsby";
import Layout from "../containers/layout";
import GraphQLErrorList from "../components/graphql-error-list";
import Container from "../components/container";
import Seo from "../components/seo";

import PageHeader from "../components/page-header-solution";
import MultiColumnContent from "../components/multi-column-content";
import FeaturedBlocks from "../components/featured-blocks";
import LogosSection from "../components/logos-section";
import CallToAction from "../components/call-to-action";

export const query = graphql`
  fragment SanityImage on SanityMainImage {
    crop {
      _key
      _type
      top
      bottom
      left
      right
    }
    hotspot {
      _key
      _type
      x
      y
      height
      width
    }
    asset {
      _id
    }
  }

  query SolutionTemplateQuery($id: String!) {
    solution: sanitySolution(id: { eq: $id }) {
      id
      pageHeader {
        description
        title
        button {
          text
          url
          blank
          secondaryButton
        }
      }
      category {
        title
      }
      multiColumnContent {
        heading
        content {
          _key
          icon {
            asset {
              _id
            }
          }
          heading
          _rawContent
          link {
            blank
            text
            url
          }
        }
      }
      featuredBlocks {
        _key
        heading
        _rawContent
        button {
          blank
          secondaryButton
          text
          url
        }
        image {
          ...SanityImage
          alt
        }
        switchOrder
      }
      logosSection {
        heading
        logos {
          _key
          ...SanityImage
          alt
        }
      }
      callToAction {
        title
        button {
          blank
          secondaryButton
          text
          url
        }
        link {
          blank
          text
          url
        }
        image {
          ...SanityImage
          alt
        }
      }
    }
  }
`;

const SolutionTemplate = (props) => {
  const { 
    data, 
    errors
  } = props;
  
  const solution = data && data.solution;

  return (
    <Layout>
      {errors && <Seo title="GraphQL Error" />}
      {solution && (
        <Seo
          title={solution.pageHeader.title}
          description={solution.pageHeader.description}
        />
      )}

      {errors && (
        <Container>
          <GraphQLErrorList errors={errors} />
        </Container>
      )}

      {solution.pageHeader && <PageHeader {...solution.pageHeader} category={solution.category.title} />}
      {solution.multiColumnContent && <MultiColumnContent {...solution.multiColumnContent} />}
      {(solution.featuredBlocks && solution.featuredBlocks.length) ? <FeaturedBlocks items={solution.featuredBlocks} /> : null}
      {solution.logosSection && <LogosSection {...solution.logosSection} />}
      {solution.callToAction && <CallToAction {...solution.callToAction} />}
    </Layout>
  );
};

export default SolutionTemplate;
